import React from 'react';

const Pagination = ({ pagination, onPageChange }) => {
  const {
    current_page: currentPage,
    last_page: totalPages,
    per_page: perPage,
    total,
  } = pagination;

  if (totalPages <= 1) return null;

  const startRecord = (currentPage - 1) * perPage + 1;
  const endRecord = Math.min(currentPage * perPage, total);

  const handlePageClick = (page) => {
    if (page !== currentPage && page > 0 && page <= totalPages) {
      onPageChange(page);
    }
  };

  const renderPageNumbers = () => {
    const pages = [];
    const maxVisible = 5; // how many page buttons to show
  
    let start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
    let end = start + maxVisible - 1;
  
    if (end > totalPages) {
      end = totalPages;
      start = Math.max(1, end - maxVisible + 1);
    }
  
    // First page
    if (start > 1) {
      pages.push(
        <button
          key={1}
          className="pagination-button"
          onClick={() => handlePageClick(1)}
        >
          1
        </button>
      );
  
      if (start > 2) {
        pages.push(<span key="start-ellipsis">...</span>);
      }
    }
  
    // Middle pages
    for (let i = start; i <= end; i++) {
      pages.push(
        <button
          key={i}
          className={`pagination-button ${currentPage === i ? 'active' : ''}`}
          onClick={() => handlePageClick(i)}
        >
          {i}
        </button>
      );
    }
  
    // Last page
    if (end < totalPages) {
      if (end < totalPages - 1) {
        pages.push(<span key="end-ellipsis">...</span>);
      }
  
      pages.push(
        <button
          key={totalPages}
          className="pagination-button"
          onClick={() => handlePageClick(totalPages)}
        >
          {totalPages}
        </button>
      );
    }
  
    return pages;
  };

  return (
    <div className="pagination-container">
      {/* Left Side: Display range and total records */}
      <div className="pagination-info">
        {`Showing ${startRecord}-${endRecord} of ${total} records`}
      </div>

      {/* Right Side: Pagination buttons */}
      <div className="pagination-buttons">
        <button
          className={`pagination-button ${
            currentPage === 1 ? 'active' : ''
          }`}
          disabled={currentPage === 1}
          onClick={() => handlePageClick(currentPage - 1)}
        >
          Prev
        </button>
        {renderPageNumbers()}
        <button
          className={`pagination-button ${
            currentPage === totalPages ? 'active' : ''
          }`}
          disabled={currentPage === totalPages}
          onClick={() => handlePageClick(currentPage + 1)}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Pagination;
